import {useSiteLanguage} from "../career/SiteLanguage";
import React, { useState, useEffect,useRef,useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/PersonelProfil.css";
import "../styles/EgitimCard.css";
import LegacyEgitimStep from "../pages/LegacyEgitimStep.js";
import EvrakPopup from "../pages/EvrakPopup.js";
import CropperPopup from "../components/CropperPopup";
import EgitimDashboard from "./mudur/EgitimDashboard";
import MagazaIlanlarim from "./mudur/MagazaIlanlarim";
import PaylasilanAdaylar from "./mudur/PaylasilanAdaylar";
import CareerProfilePhotoCard from "../career/CareerProfilePhotoCard";
import CareerPhone from "../career/CareerPhone";
import CareerMailbox from "../career/CareerMailbox";
import {requestMailNavigation} from "../career/mailNavigation";
import {useCareerLanguage} from "../career/CareerLanguage";
import {employeeMenu,profilePhone,contactPhone,contactError} from "../career/employeeProfile";
import '../career/CareerAccount.css';
import '../career/EmployeeProfile.css';
import axios from "axios";
import {
  Settings,
  UserRound,
  BookOpen,
  BadgeCheck,
  FileText,
  LayoutDashboard,
  FileQuestion,
  ClipboardList,
  CalendarClock,
  Eye,
  Download,
  PanelLeftOpen,
  PanelLeftClose,
  BriefcaseBusiness,
  Mail,
} from "lucide-react";


const egitimKartlari = [
  {
    id: 1,
    adi: "İSG Genel Konular",
    gorsel: "/images/isg.jpeg",
    aciklama: "İş sağlığı ve güvenliği temel modülleri",
    moduller: [
      { id: 1, ad: "Başlangıç", video: "/videos/0-1.mp4" },
      { id: 2, ad: "Tanım", video: "/videos/1-1.mp4" },
      { id: 3, ad: "Mevzuat", video: "/videos/1-2.mp4" },
      { id: 4, ad: "Hak ve Sorumluluklar", video: "/videos/1-3.mp4" },
      { id: 5, ad: "Düzen", video: "/videos/1-4.mp4" },
      { id: 6, ad: "Hukuki Sonuçlar", video: "/videos/1-5.mp4" },
    ],
  },
  {
    id: 2,
    adi: "İSG Sağlık Konuları",
    gorsel: "/images/isgsaglik.jpg",
    aciklama: "İş sağlığı ile ilgili konular",
    moduller: [
      { id: 1, ad: "Meslek Hastalıkları", video: "/videos/2-1.mp4" },
      { id: 2, ad: "Hastalıktan Korunma", video: "/videos/2-2.mp4" },
      { id: 3, ad: "Risk Etmenleri", video: "/videos/2-3.mp4" },
      { id: 4, ad: "İlk Yardım", video: "/videos/2-4.mp4" },
      { id: 5, ad: "Tütü Ürünleri", video: "/videos/2-5.mp4" },
    ],
  },
  {
    id: 3,
    adi: "İSG Teknik Konular",
    gorsel: "/images/isgtknık.jpeg",
    aciklama: "Bu kartın açıklaması",
    moduller: [
      { id: 1, ad: "Risk", video: "/videos/3-1.mp4" },
      { id: 2, ad: "Taşıma", video: "/videos/3-2.mp4" },
      { id: 3, ad: "Koruma", video: "/videos/3-3.mp4" },
      { id: 4, ad: "Kullanım", video: "/videos/3-4.mp4" },
      { id: 5, ad: "Çalışma", video: "/videos/3-5.mp4" },
      { id: 6, ad: "Önlemler", video: "/videos/3-6.mp4" },
      { id: 7, ad: "İşaretler", video: "/videos/3-7.mp4" },
      { id: 8, ad: "KKD", video: "/videos/3-8.mp4" },
      { id: 9, ad: "Tahliye", video: "/videos/3-9.mp4" },
    ],
  },
  {
    id: 4,
    adi: "İSG Güvenli Çalış",
    gorsel: "/images/sagliklicalis.jpeg",
    aciklama: "İş sağlığı ve güvenliği genel eğitimi",
    moduller: [{ id: 1, ad: "Genel Eğitim", video: "/videos/Guvenlicalis.mp4" }],
  },
  {
    id: 5,
    adi: "Kişisel Verilerin Korunması Kanunu",
    gorsel: "/images/kvkk.jpeg",
    aciklama: "İş sağlığı ve güvenliği genel eğitimi",
    moduller: [{ id: 1, ad: "Genel Eğitim", video: "/videos/kvkk.mp4" }],
  },
];

const PersonelProfil = () => {
  const {tx,lang} = useSiteLanguage();
  const {t}=useCareerLanguage();
  const contactBusy=useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const modulTamamlandi = location.state?.modulTamamlandi;

  const [aktifMenu, setAktifMenuImmediately] = useState(() =>
    employeeMenu(new URLSearchParams(location.search).get('sekme')==='paylasilan-adaylar'?'paylasilanAdaylar':new URLSearchParams(location.search).get('sekme')||location.state?.aktifMenu,localStorage.getItem("magazaMuduruMu")==="true")
  );
  const setAktifMenu=useCallback(value=>requestMailNavigation(()=>setAktifMenuImmediately(value)),[]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [sidebarPinned, setSidebarPinned] = useState(false);
  const [seciliEgitim, setSeciliEgitim] = useState(null);
  const [tamamlanmaDurumlari, setTamamlanmaDurumlari] = useState({});
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [sertifikaFoto, setSertifikaFoto] = useState(null);
  const [buyukSertifika, setBuyukSertifika] = useState(null);
  const [showModul4Warning, setShowModul4Warning] = useState(false);
  const [modul4WarningMessage, setModul4WarningMessage] = useState("");
  const [showEksikBilgiPopup, setShowEksikBilgiPopup] = useState(false);
  const [sinavlar, setSinavlar] = useState([]);
  const [sinavlarLoading, setSinavlarLoading] = useState(false);
  const [sinavlarError, setSinavlarError] = useState("");
  const [seciliSinav, setSeciliSinav] = useState(null);
  const [showSinavBilgiPopup, setShowSinavBilgiPopup] = useState(false);
  const [anketler, setAnketler] = useState([]);
  const [anketLoading, setAnketLoading] = useState(false);
  const [anketHata, setAnketHata] = useState("");
  const [sertifikalar, setSertifikalar] = useState([]);
  const [aktifEgitimTab, setAktifEgitimTab] = useState("tumu");
  const [egitimArama, setEgitimArama] = useState("");
  const shiftYetkisiVar = (() => {
    const storageYetki = localStorage.getItem("shiftYetkisiVar");

    if (storageYetki === "true") return true;
    if (storageYetki === "false") return false;

    try {
      const authData = JSON.parse(localStorage.getItem("authData") || "{}");

      const rolKodlari =
        authData?.user?.organizasyonRolKodlari?.$values ||
        authData?.user?.organizasyonRolKodlari ||
        [];

      const izinliRoller = [
        "ALAN_MUDURU",
        "MUDUR",
        "MAGAZA_MUDURU",
        "MUDUR_YARDIMCISI",
        "MAGAZA_MUDUR_YARDIMCISI",
      ];

      return rolKodlari.some((rol) =>
        izinliRoller.includes(String(rol).trim().toUpperCase())
      );
    } catch {
      return false;
    }
  })();


  const kullaniciAdi = localStorage.getItem("userName") || "Personel";
  const kullaniciMail = localStorage.getItem("userEmail") || "E-posta";
  const token = localStorage.getItem("token");
  const [magazaMuduruMu, setMagazaMuduruMu] = useState(() => {
    return localStorage.getItem("magazaMuduruMu") === "true";
  });
  const [ilanPaylasimErisimiVar, setIlanPaylasimErisimiVar] = useState(() => {
    return localStorage.getItem("ilanPaylasimErisimiVar") === "true";
  });
  const [adayPaylasimErisimiVar,setAdayPaylasimErisimiVar]=useState(false);
  useEffect(()=>{
    let current=true;
    if(!token){setAdayPaylasimErisimiVar(false);return;}
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/aday-paylasim/erisim`,{headers:{Authorization:`Bearer ${token}`}})
      .then(r=>{if(current)setAdayPaylasimErisimiVar(r.data?.erisimVar===true);})
      .catch(()=>{if(current)setAdayPaylasimErisimiVar(false);});
    return()=>{current=false;};
  },[token]);

  useEffect(() => {
    if (!token) return;

    const mudurRolunuKontrolEt = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/mudur/egitim-dashboard/erisim`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const erisimVar = response.data?.erisimVar === true;
        localStorage.setItem("magazaMuduruMu", erisimVar ? "true" : "false");
        setMagazaMuduruMu(erisimVar);
      } catch {
        localStorage.setItem("magazaMuduruMu", "false");
        setMagazaMuduruMu(false);
      }
    };

    mudurRolunuKontrolEt();
  }, [token]);

  useEffect(() => {
    if (!token) return;

    const ilanPaylasimErisiminiKontrolEt = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/mudur/ilanlar/erisim`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const erisimVar = response.data?.erisimVar === true;
        localStorage.setItem("ilanPaylasimErisimiVar", erisimVar ? "true" : "false");
        setIlanPaylasimErisimiVar(erisimVar);
      } catch {
        localStorage.setItem("ilanPaylasimErisimiVar", "false");
        setIlanPaylasimErisimiVar(false);
      }
    };

    ilanPaylasimErisiminiKontrolEt();
  }, [token]);

  const [profilAyarLoading, setProfilAyarLoading] = useState(false);
  const [profilAyarMesaj, setProfilAyarMesaj] = useState("");
  const [profilAyarHata, setProfilAyarHata] = useState("");
  const [profilAyar, setProfilAyar] = useState({
    email: kullaniciMail,
    phone: "",
  });
  const [contactModal, setContactModal] = useState({
    open: false,
    type: "",
    value: "",
    code: "",
    step: "value",
  });
  const [contactLoading, setContactLoading] = useState(false);
  const [contactInlineError, setContactInlineError] = useState({
    step: "",
    message: "",
  });
  const [profilFotoLoading, setProfilFotoLoading] = useState(false);
  const [cropImageUrl, setCropImageUrl] = useState(null);
  const [showCropper, setShowCropper] = useState(false);


  const getApiErrorMessage = (err, fallbackMessage) => {
    const data = err?.response?.data;

    if (typeof data === "string") return data;
    if (data?.message) return data.message;
    if (data?.title) return data.title;

    return fallbackMessage;
  };

  const getStoredUser = () => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  };

  const getStoredAuthUser = () => {
    try {
      return JSON.parse(localStorage.getItem("authData") || "{}")?.user || {};
    } catch {
      return {};
    }
  };

  const getProfilField = (data, keys) => {
    const source = data?.data || data || {};
    const storedUser = getStoredUser();
    const authUser = getStoredAuthUser();

    for (const key of keys) {
      const value = source?.[key] ?? storedUser?.[key] ?? authUser?.[key];

      if (value !== undefined && value !== null && value !== "") {
        return value;
      }
    }

    return "";
  };

  const fetchProfilAyarBilgileri = async () => {
    try {
      setProfilAyarLoading(true);
      setProfilAyarHata("");

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/Auth/GenelBilgiler`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const email =
        getProfilField(res.data, ["email", "ePosta", "mail"]) ||
        kullaniciMail;

      const phone = getProfilField(res.data, [
        "phoneNumber",
        "telefon",
        "telefonNo",
        "telefonNumarasi",
        "cepTelefonu",
      ]);

      setProfilAyar({
        email,
        phone,
      });
    } catch (err) {
      console.error("Profil ayar bilgileri alınamadı:", err);
      setProfilAyar({
        email: kullaniciMail,
        phone:
          getProfilField({}, [
            "phoneNumber",
            "telefon",
            "telefonNo",
            "telefonNumarasi",
            "cepTelefonu",
          ]) || "",
      });
    } finally {
      setProfilAyarLoading(false);
    }
  };

  const openContactModal = (type) => {
    if(contactBusy.current)return;
    setProfilAyarMesaj("");
    setProfilAyarHata("");
    setContactInlineError({ step: "", message: "" });
    setContactModal({
      open: true,
      type,
      value: type === "email" ? profilAyar.email || "" : contactPhone(profilAyar.phone)||"",
      code: "",
      step: "value",
    });
  };

  const closeContactModal = () => {
    setContactInlineError({ step: "", message: "" });
    setContactModal({
      open: false,
      type: "",
      value: "",
      code: "",
      step: "value",
    });
    setContactLoading(false);
  };

  const handleContactValueChange = (value) => {
    setContactInlineError({ step: "", message: "" });

    setContactModal((prev) => ({
      ...prev,
      value,
    }));
  };

  const handleContactCodeChange = (code) => {
    setContactInlineError({ step: "", message: "" });
    setContactModal((prev) => ({
      ...prev,
      code,
    }));
  };

  const handleContactChangeRequest = async () => {
    if(contactBusy.current)return;
    const cleanValue =
      contactModal.type === "phone"
        ? contactPhone(contactModal.value)
        : contactModal.value.trim();

    if (!cleanValue) {
      setContactInlineError({
        step: "value",
        message: contactModal.type==='phone'?t('phoneInvalid'):t('authRequired'),
      });
      return;
    }
    if (contactModal.type === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

      if (!emailRegex.test(cleanValue)) {
        setContactInlineError({
          step: "value",
          message:t('authInvalidEmail'),
        });
        return;
      }
    }

    try {
      contactBusy.current=true;
      setContactLoading(true);
      setProfilAyarHata("");
      setProfilAyarMesaj("");

      const response=await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/Auth/contact-change/request`,
        {
          type: contactModal.type,
          value: cleanValue,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if(response.data?.success!==true)throw new Error('Unconfirmed contact request');
      setContactModal((prev) => ({
        ...prev,
        value: cleanValue,
        code: "",
        step: "code",
        verificationChannel:response.data.verificationChannel||(contactModal.type==='email'?'email':'phone'),
      }));

      setProfilAyarMesaj("");
      setContactInlineError({ step: "", message: "" });

    } catch (err) {
      setContactInlineError({
        step: "value",
        message: t(contactError(err)),
      });
    } finally {
      contactBusy.current=false;
      setContactLoading(false);
    }
  };

  const handleContactChangeConfirm = async () => {
    if(contactBusy.current)return;
    const cleanCode = contactModal.code.trim();
    const cleanContactValue =
      contactModal.type === "phone"
        ? contactPhone(contactModal.value)
        : contactModal.value.trim();

    if (!cleanCode) {
      setContactInlineError({
        step: "code",
        message:t('contactInvalidCodeMessage'),
      });
      return;
    }

    try {
      contactBusy.current=true;
      setContactLoading(true);
      setProfilAyarHata("");
      setContactInlineError({ step: "", message: "" });

      const response=await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/Auth/contact-change/confirm`,
        {
          type: contactModal.type,
          value: cleanContactValue,
          code: cleanCode,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if(response.data?.success!==true)throw new Error('Unconfirmed contact update');
      setProfilAyar((prev) => ({
        ...prev,
        [contactModal.type === "email" ? "email" : "phone"]:
          response.data.value||cleanContactValue,
      }));

      if (contactModal.type === "email") {
        localStorage.setItem("userEmail", cleanContactValue);
      }

      setProfilAyarMesaj(
        t(contactModal.type==='email'?'contactEmailSaved':'contactPhoneSaved')
      );

      closeContactModal();
    } catch (err) {
      setContactInlineError({
        step: "code",
        message: t(contactError(err)),
      });
    } finally {
      contactBusy.current=false;
      setContactLoading(false);
    }
  };

  const handleProfilFotoDegistir = (e) => {
    if (profilFotoLoading) {
      setProfilAyarHata("Profil fotoğrafı kaydediliyor, lütfen bekleyin.");
      return;
    }

    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setProfilAyarHata("Lütfen geçerli bir görsel dosyası yükleyin.");
      e.target.value = "";
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setProfilAyarHata("Fotoğraf boyutu en fazla 5 MB olabilir.");
      e.target.value = "";
      return;
    }

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      if (img.width < 200 || img.height < 200) {
        setProfilAyarHata("Lütfen daha net bir profil fotoğrafı yükleyin.");
        URL.revokeObjectURL(objectUrl);
        e.target.value = "";
        return;
      }

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = 80;
      canvas.height = 80;
      ctx.drawImage(img, 0, 0, 80, 80);

      const pixels = ctx.getImageData(0, 0, 80, 80).data;
      const brightnessValues = [];

      for (let i = 0; i < pixels.length; i += 4) {
        const r = pixels[i];
        const g = pixels[i + 1];
        const b = pixels[i + 2];
        const brightness = (r + g + b) / 3;
        brightnessValues.push(brightness);
      }

      const average =
        brightnessValues.reduce((sum, val) => sum + val, 0) /
        brightnessValues.length;

      const variance =
        brightnessValues.reduce(
          (sum, val) => sum + Math.pow(val - average, 2),
          0
        ) / brightnessValues.length;

      if (variance < 20) {
        setProfilAyarHata("Boş, düz renk veya geçersiz fotoğraf yüklenemez.");
        URL.revokeObjectURL(objectUrl);
        e.target.value = "";
        return;
      }

      setProfilAyarHata("");
      setProfilAyarMesaj("");

      const reader = new FileReader();
      reader.onloadend = () => {
        setCropImageUrl(reader.result);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);

      URL.revokeObjectURL(objectUrl);
      e.target.value = "";
    };

    img.onerror = () => {
      setProfilAyarHata("Fotoğraf okunamadı. Lütfen farklı bir görsel deneyin.");
      URL.revokeObjectURL(objectUrl);
      e.target.value = "";
    };

    img.src = objectUrl;
  };


  const [egitimler, setEgitimler] = useState([]);
  const [egitimlerLoading, setEgitimlerLoading] = useState(false);
  const [egitimlerError, setEgitimlerError] = useState("");

  const egitimIlerlemesiniGetir = async (modulEgitimId, signal) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimleri/ilerleme/${modulEgitimId}`,
        {
          signal,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return res.data;
    } catch (err) {
      if (signal?.aborted) throw err;
      console.error("Eğitim ilerleme alınamadı:", modulEgitimId, err);
      return null;
    }
  };

  const fetchEgitimlerim = async (signal) => {
    try {
      setEgitimlerLoading(true);
      setEgitimlerError("");

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimleri/benim`,
        {
          signal,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const liste = res.data?.$values || [];

      const ilerlemeliListe = await Promise.all(
        liste.map(async (egitim) => {
          const ilerleme = await egitimIlerlemesiniGetir(egitim.egitimId, signal);

          return {
            ...egitim,
            ilerleme,
            tamamlanmaYuzdesi:
              ilerleme?.tamamlanmaYuzdesi ?? egitim.tamamlanmaYuzdesi ?? 0,
            aktifSayfaId:
              ilerleme?.aktifSayfaId ?? egitim.aktifSayfaId ?? null,
            baslandiMi:
              ilerleme?.baslandiMi ?? egitim.baslandiMi ?? false,
            tamamlandiMi:
              ilerleme?.tamamlandiMi ?? egitim.tamamlandiMi ?? false,
            basariliMi:
              ilerleme?.basariliMi ?? egitim.basariliMi ?? false,
            tamamlanabilirMi:
              ilerleme?.tamamlanabilirMi ?? false,
            eksikler:
              ilerleme?.eksikler?.$values || [],
          };
        })
      );

      if (!signal?.aborted) setEgitimler(ilerlemeliListe);
    } catch (err) {
      if (signal?.aborted) return;
      console.error("Eğitimler alınamadı:", err);
      setEgitimler([]);
      setEgitimlerError("Eğitimler yüklenirken bir sorun oluştu.");
    } finally {
      if (!signal?.aborted) setEgitimlerLoading(false);
    }
  };

  useEffect(() => {
    const eksikBilgiPopupGoster =
      sessionStorage.getItem("showKanGrubuPopup") === "true";

    if (eksikBilgiPopupGoster) {
      setShowEksikBilgiPopup(true);
    }
  }, []);

  useEffect(() => {
    if (!token || aktifMenu !== 'egitimler') return;
    const controller = new AbortController();
    fetchEgitimlerim(controller.signal);
    return () => controller.abort();
  }, [token, aktifMenu]);

  useEffect(() => {
    if (!token || aktifMenu !== 'sertifikalar') return;
    const controller = new AbortController();
    const urls = [];
    const fetchSertifikalar = async () => {
      try {
        const listeRes = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/VerilenSertifika/benim`,
          {
            signal: controller.signal,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const liste = listeRes.data?.data?.$values || [];

        const sertifikalarFotoIle = await Promise.all(
          liste.map(async (sertifika) => {
            try {
              const fotoRes = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/VerilenSertifika/benim-foto/${sertifika.kaynak}/${sertifika.id}`,
                {
                  signal: controller.signal,
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                  responseType: "blob",
                }
              );

              if (controller.signal.aborted) return null;
              const fotoBlobUrl = URL.createObjectURL(fotoRes.data);
              urls.push(fotoBlobUrl);
              return {
                ...sertifika,
                fotoBlobUrl,
              };
            } catch (err) {
              if (controller.signal.aborted) return null;
              console.error("Sertifika foto alınamadı:", sertifika, err);
              return {
                ...sertifika,
                fotoBlobUrl: null,
              };
            }
          })
        );

        if (!controller.signal.aborted) setSertifikalar(sertifikalarFotoIle.filter(Boolean));
      } catch (err) {
        if (controller.signal.aborted) return;
        console.error("Sertifikalar alınamadı:", err);
        setSertifikalar([]);
      }
    };

    setSertifikalar([]);
    fetchSertifikalar();
    return () => {controller.abort(); urls.forEach(url => URL.revokeObjectURL(url));};
  }, [token, aktifMenu]);


  useEffect(() => {
    const fetchProfilePhoto = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppbak`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "blob",
          }
        );
        const imgUrl = URL.createObjectURL(res.data);
        setProfilePhoto(imgUrl);
      } catch (err) {
        console.error("Profil fotoğrafı alınamadı:", err);
      }
    };
    if (token) fetchProfilePhoto();
  }, [token]);

  useEffect(() => {
    if (token && aktifMenu === 'profilAyarlari') {
      fetchProfilAyarBilgileri();
    }
  }, [token, aktifMenu]);

  useEffect(() => {
    const fetchTamamlanmaDurumlari = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/Isg/modul-durumlarim`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const list = res.data?.$values || res.data || [];
        const durumMap = {};

        list.forEach((item) => {
          if (item && typeof item.modul !== "undefined") {
            durumMap[item.modul] = item.basariDurumu === true;
          }
        });

        setTamamlanmaDurumlari(durumMap);
      } catch (err) {
        console.error("Modül durumları alınamadı:", err);
      }
    };

    if (token && aktifMenu === 'egitimler') fetchTamamlanmaDurumlari();
  }, [token, aktifMenu]);

  useEffect(() => {
    if (modulTamamlandi) {
      setTamamlanmaDurumlari((prev) => ({
        ...prev,
        [modulTamamlandi]: true,
      }));
    }
  }, [modulTamamlandi]);

  useEffect(() => {
    if (token && aktifMenu === 'sinavlar') {
      fetchSinavlar();
    }
  }, [token, aktifMenu]);

  useEffect(() => {
    if (aktifMenu === "anketlerim") {
      fetchBagimsizAnketlerim();
    }
  }, [aktifMenu]);

  const fetchSinavlar = async () => {
    try {
      setSinavlarLoading(true);
      setSinavlarError("");

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciSinav/sinavlarim`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const liste = res.data?.$values || [];
      setSinavlar(liste);
    } catch (err) {
      console.error("Sınavlar alınamadı:", err);
      setSinavlar([]);
      setSinavlarError("Sınavlar yüklenirken hata oluştu.");
    } finally {
      setSinavlarLoading(false);
    }
  };

  const getEgitimKapakUrl = (kapakResimUrl) => {
    if (!kapakResimUrl) return "/images/default.jpg";

    if (
      kapakResimUrl.startsWith("http://") ||
      kapakResimUrl.startsWith("https://")
    ) {
      return kapakResimUrl;
    }

    return `${process.env.REACT_APP_API_BASE_URL}${kapakResimUrl}`;
  };

  const getEgitimButonText = (egitim) => {
    if (egitim.tamamlandiMi) {
      return "Tamamlandı";
    }

    if (egitim.baslandiMi) {
      return "Devam Et";
    }

    return "Başla";
  };


  const getSinavKapakUrl = (kapakFotoUrl) => {
    if (!kapakFotoUrl) return null;

    if (
      kapakFotoUrl.startsWith("http://") ||
      kapakFotoUrl.startsWith("https://")
    ) {
      return kapakFotoUrl;
    }

    return `${process.env.REACT_APP_API_BASE_URL}${kapakFotoUrl}`;
  };

  const formatTarih = (tarih) => {
    if (!tarih) return "-";

    const parsed = new Date(tarih);

    if (Number.isNaN(parsed.getTime())) {
      return "-";
    }

    return parsed.toLocaleDateString(lang);
  };

  const handleSinavPopupAc = (sinav) => {
    setSeciliSinav(sinav);
    setShowSinavBilgiPopup(true);
  };

  const handleSinavPopupKapat = () => {
    setShowSinavBilgiPopup(false);
    setSeciliSinav(null);
  };

  const handleSinavBaslat = async () => {
    if (!seciliSinav) return;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciSinav/baslat`,
        {
          sinavId: seciliSinav.sinavId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const kullaniciSinavId =
        res.data?.kullaniciSinavId ||
        res.data?.id ||
        res.data?.data?.kullaniciSinavId;

      if (!kullaniciSinavId) {
        console.error("kullaniciSinavId bulunamadı:", res.data);
        return;
      }

      const soruIdleri = res.data?.randomSoruIcerikIdleri?.$values || [];

      const sinavState = {
        sinavBaslik: seciliSinav.baslik,
        sinavId: seciliSinav.sinavId,
        kullaniciSinavId,
        toplamSoru: res.data?.toplamSoru,
        kalanSureSaniye: res.data?.kalanSureSaniye,
        ilkSiraNo: res.data?.ilkSiraNo || 1,
        soruIdleri,
        fromProfilSinav: true,
      };

      sessionStorage.setItem(
        `sinavState_${kullaniciSinavId}`,
        JSON.stringify(sinavState)
      );

      setShowSinavBilgiPopup(false);
      setSeciliSinav(null);

      navigate(`/personel/sinav/${kullaniciSinavId}`, {
        state: sinavState,
      });

    } catch (err) {
      console.error("Sınav başlatılamadı:", err);
    }
  };

  const handleAnketBaslat = async (anket) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimAnket/baslat`,
        {
          modulEgitimKullaniciSurecId: null,
          modulEgitimAnketId: anket.modulEgitimAnketId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const anketState = {
        baslik: anket.baslik,
        modulEgitimAnketId: anket.modulEgitimAnketId,
        modulEgitimKullaniciSurecId: null,
        toplamSoru: res.data?.toplamSoru || anket.toplamSoru,
        ilkSiraNo: res.data?.ilkSiraNo || 1,
        kalanSureSaniye: res.data?.kalanSureSaniye || null,
        fromProfilAnket: true,
      };
      sessionStorage.setItem(
        `anketState_${anket.modulEgitimAnketId}`,
        JSON.stringify(anketState)
      );

      navigate(`/personel/anket/${anket.modulEgitimAnketId}`, {
        state: anketState,
      });
    } catch (err) {
      console.error("Anket başlatılamadı:", err);
    }
  };

  const fetchBagimsizAnketlerim = async () => {
    try {
      setAnketLoading(true);
      setAnketHata("");

      const token = localStorage.getItem("token");

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimAnket/bagimsiz-anketlerim`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Anketler getirilemedi.");
      }

      const data = await response.json();
      const liste = data?.$values || [];

      const anketlerFotoIle = await Promise.all(
        liste.map(async (anket) => {
          try {
            const fotoRes = await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimAnket/kapakfoto/${anket.modulEgitimAnketId}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
                responseType: "blob",
              }
            );

            return {
              ...anket,
              kapakBlobUrl: URL.createObjectURL(fotoRes.data),
            };
          } catch (err) {
            console.error("Anket kapak foto alınamadı:", anket, err);

            return {
              ...anket,
              kapakBlobUrl: null,
            };
          }
        })
      );

      setAnketler(anketlerFotoIle);
    } catch (error) {
      console.error("Anket listeleme hatası:", error);
      setAnketHata("Anketler yüklenirken bir sorun oluştu.");
    } finally {
      setAnketLoading(false);
    }
  };

  const getAnketKapakUrl = (modulEgitimAnketId) => {
    return `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimAnket/kapakfoto/${modulEgitimAnketId}`;
  };

  const handleLegacyKatil = async (egitim) => {
    if (tamamlanmaDurumlari[egitim.id]) return;

    if (egitim.id === 4) {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/Isg/modul4-aktif-mi`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = res.data;
        const aktif = data.modul4Aktif === true;

        if (!aktif) {
          const eksikIds =
            data.eksikModuller?.$values ||
            data.eksikModuller?.values ||
            data.eksikModuller ||
            [];

          let mesaj = "";

          if (Array.isArray(eksikIds) && eksikIds.length > 0) {
            const eksikAdlar = eksikIds
              .map((id) => {
                const kart = egitimKartlari.find((e) => e.id === id);
                return kart ? kart.adi : `Modül ${id}`;
              })
              .filter(Boolean);

            mesaj = `"${egitim.adi}" modülüne geçmeden önce şu eğitimleri tamamlamalısınız: ${eksikAdlar.join(", ")}.`;
          } else {
            mesaj = `"${egitim.adi}" modülüne geçmeden önce önceki eğitimleri tamamlamalısınız.`;
          }

          setModul4WarningMessage(mesaj);
          setShowModul4Warning(true);
          return;
        }
      } catch (err) {
        console.error("modul4-aktif-mi kontrol hatası:", err);
      }
    }

    setSeciliEgitim(egitim);
  };


  const handleYeniEgitimKatil = async (egitim) => {
    if (egitim.tamamlandiMi) return;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciEgitimleri/basla/${egitim.atamaId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      navigate(`/personel/egitim/${egitim.egitimId}`, {
        state: {
          egitim: {
            ...egitim,
            surecId: res.data?.surecId,
            aktifSayfaId: res.data?.aktifSayfaId,
          },
        },
      });
    } catch (err) {
      console.error("Eğitim başlatılamadı:", err);
    }
  };

 
  const renderContactInlineForm = (type) => {
    if (!contactModal.open || contactModal.type !== type) return null;

    const isEmail = type === "email";

    const hedefBilgi = isEmail
      ? contactModal.value
      : profilePhone(contactModal.value);

    const contactDescription =
      contactModal.step === "code"
        ? isEmail
          ? `${hedefBilgi} · ${tx("Doğrulama kodu gönderildi.")}`
          : contactModal.verificationChannel==='email'?t('contactEmailCodeSent'):`${hedefBilgi} · ${tx("Doğrulama kodu gönderildi.")}`
        : isEmail
          ? tx("Yeni e-posta adresinize gelen kod ile değişikliği onaylayın.")
          : t('contactPhoneIntro');

    return (
      <div className="profil-contact-inline">
        <div className="profil-contact-inline-header">
          <div>
            <h3>{isEmail ? tx("E-posta Değiştir") : tx("Telefon Değiştir")}</h3>
            <p
              className={
                contactModal.step === "code" ? "profil-contact-inline-sent" : ""
              }
            >
              {contactDescription}
            </p>
          </div>
        </div>

        {contactModal.step === "value" && (
          <>
            <div className={'profil-contact-inline-form'+(!isEmail?' profil-contact-number-form':'')}>
              {isEmail?<input type="email" inputMode="email" value={contactModal.value} onChange={e=>handleContactValueChange(e.target.value)} disabled={contactLoading} placeholder={tx("Yeni e-posta adresinizi giriniz")}/>:<div className="profil-contact-phone"><CareerPhone value={contactModal.value} onChange={handleContactValueChange} disabled={contactLoading}/></div>}

              <button
                type="button"
                className="profil-contact-inline-submit"
                onClick={handleContactChangeRequest}
                disabled={contactLoading}
              >
                {contactLoading ? tx("Gönderiliyor...") : tx("Kod Gönder")}
              </button>
            </div>

            {contactInlineError.step === "value" && contactInlineError.message && (
              <p className="profil-contact-inline-error" role="alert">
                {contactInlineError.message}
              </p>
            )}
          </>
        )}

        {contactModal.step === "code" && (
          <>
            <div className="profil-contact-inline-form">
              <input
                type="text"
                value={contactModal.code}
                inputMode="numeric" autoComplete="one-time-code" maxLength={6} disabled={contactLoading}
                aria-label={tx("Doğrulama kodu")}
                onChange={(e) => handleContactCodeChange(e.target.value)}
                placeholder={tx("Doğrulama kodu")}
              />

              <button
                type="button"
                className="profil-contact-inline-submit"
                onClick={handleContactChangeConfirm}
                disabled={contactLoading}
              >
                {contactLoading ? tx("Onaylanıyor...") : tx("Değişikliği Onayla")}
              </button>
            </div>

            {contactInlineError.step === "code" && contactInlineError.message && (
              <p className="profil-contact-inline-error" role="alert">
                {contactInlineError.message}
              </p>
            )}
            <button type="button" className="profil-contact-back" disabled={contactLoading} onClick={()=>{setContactInlineError({step:'',message:''});setContactModal(prev=>({...prev,step:'value',code:''}));}}>{t('contactEdit')}</button>
          </>
        )}

      </div>
    );
  };

  const handleEksikBilgiTamam = () => {
    sessionStorage.removeItem("showKanGrubuPopup");
    sessionStorage.setItem("focusKanGrubu", "true");

    setShowEksikBilgiPopup(false);
    navigate("/ozgecmisim");
  };

  const renderIcerik = () => {
    switch (aktifMenu) {

      case "egitimler": {
        const tumEgitimler = [
          ...egitimKartlari.map((egitim) => {
            const tamamlandi = !!tamamlanmaDurumlari[egitim.id];

            return {
              kaynak: "legacy",
              id: egitim.id,
              baslik: egitim.adi,
              gorsel: egitim.gorsel,
              tamamlandiMi: tamamlandi,
              yuzde: tamamlandi ? 100 : 0,
              butonText: tamamlandi ? "Tamamlandı" : "Başla",
              raw: egitim,
            };
          }),

          ...egitimler.map((egitim) => ({
            kaynak: "yeni",
            id: egitim.egitimId,
            baslik: egitim.baslik,
            gorsel: getEgitimKapakUrl(egitim.kapakResimUrl),
            tamamlandiMi:
              Boolean(egitim.tamamlandiMi),
            yuzde: egitim.tamamlanmaYuzdesi || 0,
            butonText: getEgitimButonText(egitim),
            raw: egitim,
          })),
        ];

        const egitimDurumuGetir = (egitim) => {
          const tamamlandi = Boolean(egitim.tamamlandiMi);
          const basladi =
            egitim.raw?.baslandiMi ||
            egitim.raw?.baslandi ||
            egitim.yuzde > 0;

          if (tamamlandi) return "tamamlananlar";
          if (basladi) return "devam";
          return "baslamayanlar";
        };

        const egitimTablari = [
          { key: "tumu", label: "Tümü" },
          { key: "devam", label: "Devam Ettiklerim" },
          { key: "baslamayanlar", label: "Başlamadıklarım" },
          { key: "tamamlananlar", label: "Tamamladıklarım" },
        ];

        const egitimSayilari = egitimTablari.reduce((acc, tab) => {
          acc[tab.key] =
            tab.key === "tumu"
              ? tumEgitimler.length
              : tumEgitimler.filter((egitim) => egitimDurumuGetir(egitim) === tab.key)
                .length;

          return acc;
        }, {});
        const tabIleFiltrelenmisEgitimler =
          aktifEgitimTab === "tumu"
            ? tumEgitimler
            : tumEgitimler.filter(
              (egitim) => egitimDurumuGetir(egitim) === aktifEgitimTab
            );

        const aramaMetni = egitimArama.trim().toLocaleLowerCase("tr-TR");

        const filtrelenmisEgitimler = tabIleFiltrelenmisEgitimler.filter((egitim) => {
          if (!aramaMetni) return true;

          const aranacakAlan = [
            egitim.baslik,
            egitim.aciklama,
            egitim.kategori,
            egitim.raw?.baslik,
            egitim.raw?.egitimAdi,
            egitim.raw?.aciklama,
          ]
            .filter(Boolean)
            .join(" ")
            .toLocaleLowerCase("tr-TR");

          return aranacakAlan.includes(aramaMetni);
        });

        return (
          <div className="personel-icerik">
            <h2>{tx("Eğitimlerim")}</h2>

            <div className="egitim-search-row">
              <input
                type="text"
                value={egitimArama}
                onChange={(e) => setEgitimArama(e.target.value)}
                placeholder={tx("Eğitim ara...")}
              />

              {egitimArama && (
                <button type="button" onClick={() => setEgitimArama("")}>{tx("Temizle")}</button>
              )}
            </div>


            <div className="egitim-tabs">
              {egitimTablari.map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  className={aktifEgitimTab === tab.key ? "aktif" : ""}
                  onClick={() => setAktifEgitimTab(tab.key)}
                >
                  {tx(tab.label)}
                  <span>{egitimSayilari[tab.key]}</span>
                </button>
              ))}
            </div>

            {egitimlerLoading && (
              <p className="sinav-bilgi-mesaji">{tx("Eğitimler yükleniyor...")}</p>
            )}

            {!egitimlerLoading && egitimlerError && (
              <p className="sinav-hata-mesaji">{egitimlerError}</p>
            )}

            {!egitimlerLoading &&
              !egitimlerError &&
              tumEgitimler.length > 0 &&
              filtrelenmisEgitimler.length === 0 && (
                <p className="sinav-bos-mesaj">
                  {egitimArama
                    ? "Aramanıza uygun eğitim bulunamadı."
                    : "Bu filtrede gösterilecek eğitim bulunmamaktadır."}
                </p>
              )}

            {tumEgitimler.length > 0 && (
              <div
                className={`egitim-card-list ${sidebarCollapsed ? "sidebar-kapali" : "sidebar-acik"
                  }`}
              >
                {filtrelenmisEgitimler.map((egitim) => (
                  <div
                    className="egitim-kart"
                    key={`${egitim.kaynak}-${egitim.id}`}
                  >
                    <div className="egitim-kart-header">
                      <img
                        src={egitim.gorsel || "/images/default.jpg"}
                        alt={egitim.baslik}
                        className="egitim-kart-gorsel"
                        onError={(e) => {
                          e.currentTarget.src = "/images/default.jpg";
                        }}
                      />
                    </div>

                    <div className="egitim-kart-alt">
                      <div className="egitim-logo">
                        <img src="/images/fulla.png" alt="Logo" />
                      </div>

                      <div className="egitim-baslik">
                        <span>{egitim.baslik}</span>

                        <div className="sinav-alt-bilgi">
                          <span className="sinav-mini-tarih">{tx("İlerleme: %")}{egitim.yuzde}
                          </span>

                          <span
                            className={`sinav-mini-durum ${egitim.tamamlandiMi ? "tamamlandi" : "bekliyor"
                              }`}
                          >
                            {tx(egitim.tamamlandiMi ? "Tamamlandı" : "Hazır")}
                          </span>
                        </div>
                      </div>

                      <div className="egitim-butonu">
                        <button
                          disabled={egitim.tamamlandiMi}
                          className={
                            egitim.tamamlandiMi ? "egitim-btn-tamamlandi" : ""
                          }
                          onClick={() => {
                            if (egitim.tamamlandiMi) return;

                            if (egitim.kaynak === "legacy") {
                              handleLegacyKatil(egitim.raw);
                            } else {
                              handleYeniEgitimKatil(egitim.raw);
                            }
                          }}
                        >
                          {tx(egitim.butonText)}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      }

      case "sertifikalar":
        return (
          <div className="personel-icerik sertifika-page">
            <div className="sertifika-header">
              <div>
                <span className="sertifika-eyebrow">{tx("PERSONEL BELGELERİ")}</span>
                <h2>{tx("Sertifikalarım")}</h2>
                <p>{tx("Tamamladığınız eğitimlere ait sertifikalarınızı buradan görüntüleyebilirsiniz.")}</p>
              </div>

              <div className="sertifika-total-badge">
                <BadgeCheck size={20} strokeWidth={2.4} />
                <span>{sertifikalar.length}{tx("Sertifika")}</span>
              </div>
            </div>

            <div className="sertifika-stats">
              <div className="sertifika-stat-card">
                <strong>{sertifikalar.length}</strong>
                <span>{tx("Toplam Sertifika")}</span>
              </div>

              <div className="sertifika-stat-card">
                <strong>{sertifikalar.length > 0 ? "Aktif" : "-"}</strong>
                <span>{tx("Sertifika Durumu")}</span>
              </div>

              <div className="sertifika-stat-card">
                <strong>{sertifikalar[0]?.sertifikaAdi || "-"}</strong>
                <span>{tx("Son Sertifika")}</span>
              </div>
            </div>

            {sertifikalar.length > 0 ? (
              <div className="sertifika-kart-wrapper">
                {sertifikalar.map((sertifika) => {
                  const sertifikaTarihi =
                    sertifika.verilisTarihi ||
                    sertifika.olusturmaTarihi ||
                    sertifika.tarih ||
                    null;

                  return (
                    <div
                      key={`${sertifika.kaynak}-${sertifika.id}`}
                      className="sertifika-kart"
                    >
                      <div
                        className="sertifika-img-wrap"
                        onClick={() => {
                          if (sertifika.fotoBlobUrl) {
                            setBuyukSertifika(sertifika.fotoBlobUrl);
                          }
                        }}
                      >
                        <span className="sertifika-badge">{tx("Sertifika")}</span>

                        {sertifika.fotoBlobUrl ? (
                          <img
                            src={sertifika.fotoBlobUrl}
                            alt={sertifika.sertifikaAdi}
                            className="sertifika-img"
                          />
                        ) : (
                          <div className="sertifika-img-placeholder">{tx("Sertifika görseli yüklenemedi")}</div>
                        )}
                      </div>

                      <div className="sertifika-body">
                        <h3>{sertifika.sertifikaAdi}</h3>

                        <div className="sertifika-meta">
                          <span>{sertifika.kaynak || "Personel Sertifikası"}</span>
                          <span>
                            {sertifikaTarihi
                              ? new Date(sertifikaTarihi).toLocaleDateString(lang)
                              : "Tarih bilgisi yok"}
                          </span>
                        </div>

                        <div className="sertifika-actions">
                          <button
                            type="button"
                            onClick={() => {
                              if (sertifika.fotoBlobUrl) {
                                setBuyukSertifika(sertifika.fotoBlobUrl);
                              }
                            }}
                          >
                            <Eye size={17} strokeWidth={2.4} />{tx("Görüntüle")}</button>

                          {sertifika.fotoBlobUrl && (
                            <a
                              href={sertifika.fotoBlobUrl}
                              download={`${sertifika.sertifikaAdi || "sertifika"}.png`}
                            >
                              <Download size={17} strokeWidth={2.4} />{tx("İndir")}</a>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="sertifika-empty">
                <BadgeCheck size={34} strokeWidth={2.2} />
                <strong>{tx("Henüz sertifikanız bulunmuyor")}</strong>
                <p>{tx("Eğitimleri tamamladığınızda sertifikalarınız burada listelenecek.")}</p>
              </div>
            )}
          </div>
        );

      case "evraklar":
        return (
          <div className="personel-icerik personel-documents">
            <h2>{tx("Evraklarım")}</h2>
            <EvrakPopup inline/>
          </div>
        );


      case "sinavlar":
        return (
          <div className="personel-icerik">
            <h2>{tx("Sınavlarım")}</h2>

            {sinavlarLoading && (
              <p className="sinav-bilgi-mesaji">{tx("Sınavlar yükleniyor...")}</p>
            )}

            {!sinavlarLoading && sinavlarError && (
              <p className="sinav-hata-mesaji">{sinavlarError}</p>
            )}

            {!sinavlarLoading && !sinavlarError && sinavlar.length === 0 && (
              <p className="sinav-bos-mesaj">{tx("Henüz size atanmış bir sınav bulunmamaktadır.")}</p>
            )}

            {!sinavlarLoading && !sinavlarError && sinavlar.length > 0 && (
              <div
                className={`sinavlar-grid ${sidebarCollapsed ? "sidebar-kapali" : "sidebar-acik"
                  }`}
              >
                {sinavlar.map((sinav) => (
                  <div className="egitim-kart sinav-egitim-kart" key={sinav.atamaId}>
                    <div className="egitim-kart-header">
                      {sinav.kapakFotoUrl ? (
                        <img
                          src={getSinavKapakUrl(sinav.kapakFotoUrl)}
                          alt={sinav.baslik}
                          className="egitim-kart-gorsel"
                          onError={(e) => {
                            e.currentTarget.style.display = "none";
                          }}
                        />
                      ) : (
                        <div className="sinav-kapak-placeholder">
                          <p>{tx("Eğitim görseli yok")}</p>
                        </div>
                      )}
                    </div>

                    <div className="egitim-kart-alt">
                      <div className="egitim-logo">
                        <img src="/images/fulla.png" alt="Logo" />
                      </div>

                      <div className="egitim-baslik sinav-egitim-baslik">
                        <span>{sinav.baslik}</span>

                        <div className="sinav-alt-bilgi">
                          <span className="sinav-mini-tarih">{tx("Son Giriş Tarihi:")}{sinav.sonTarih ? formatTarih(sinav.sonTarih) : "-"}
                          </span>

                          <span
                            className={`sinav-mini-durum ${sinav.sonGectiMi === true
                              ? "gecti"
                              : sinav.sonGectiMi === false
                                ? "kaldi"
                                : "bekliyor"
                              }`}
                          >
                            {sinav.sonGectiMi === true
                              ? tx("Geçti")
                              : sinav.sonGectiMi === false
                                ? tx("Kaldı")
                                : "Hazır"}
                          </span>
                        </div>
                      </div>

                      <div className="egitim-butonu">
                        <button
                          disabled={sinav.sonGectiMi === true}
                          className={sinav.sonGectiMi === true ? "egitim-btn-tamamlandi" : ""}
                          onClick={() => {
                            if (sinav.sonGectiMi === true) return;
                            handleSinavPopupAc(sinav);
                          }}
                        >
                          {sinav.sonGectiMi === true
                            ? tx("Tamamlandı")
                            : sinav.sonGectiMi === false
                              ? "Tekrar Başla"
                              : "Sınava Başla"}
                        </button>
                      </div>
                    </div>
                  </div>

                ))}
              </div>
            )}
          </div>
        );

      case "anketlerim":
        return (
          <div className="personel-icerik">
            <h2>{tx("Anketlerim")}</h2>

            {anketLoading && (
              <p className="sinav-bilgi-mesaji">{tx("Anketler yükleniyor...")}</p>
            )}

            {!anketLoading && anketHata && (
              <p className="sinav-hata-mesaji">
                {anketHata}
              </p>
            )}

            {!anketLoading &&
              !anketHata &&
              anketler.length === 0 && (
                <p className="sinav-bos-mesaj">{tx("Henüz size atanmış bir anket bulunmamaktadır.")}</p>
              )}

            {!anketLoading &&
              !anketHata &&
              anketler.length > 0 && (
                <div
                  className={`sinavlar-grid ${sidebarCollapsed ? "sidebar-kapali" : "sidebar-acik"
                    }`}
                >
                  {anketler.map((anket) => (
                    <div
                      className="egitim-kart sinav-egitim-kart"
                      key={anket.atamaId}
                    >
                      <div className="egitim-kart-header">
                        {anket.kapakBlobUrl ? (
                          <img
                            src={anket.kapakBlobUrl}
                            alt={anket.baslik}
                            className="egitim-kart-gorsel"
                          />
                        ) : (
                          <div className="sinav-kapak-placeholder">
                            <p>📋</p>
                          </div>
                        )}
                      </div>

                      <div className="egitim-kart-alt">
                        <div className="egitim-logo">
                          <img
                            src="/images/fulla.png"
                            alt="Logo"
                          />
                        </div>

                        <div className="egitim-baslik sinav-egitim-baslik">
                          <span>{anket.baslik}</span>

                          <div className="sinav-alt-bilgi">
                            <span className="sinav-mini-tarih">{tx("Son Tarih:")}{" "}
                              {anket.sonTarih
                                ? formatTarih(anket.sonTarih)
                                : "-"}
                            </span>

                            <span
                              className={`sinav-mini-durum ${anket.tamamlandiMi
                                ? "tamamlandi"
                                : anket.suresiDolduMu
                                  ? "suresi-doldu"
                                  : "bekliyor"
                                }`}
                            >
                              {anket.tamamlandiMi
                                ? tx("Tamamlandı")
                                : anket.suresiDolduMu
                                  ? "Süresi Doldu"
                                  : "Hazır"}
                            </span>
                          </div>
                        </div>

                        <div className="egitim-butonu">
                          <button
                            disabled={anket.tamamlandiMi === true}
                            className={anket.tamamlandiMi === true ? "egitim-btn-tamamlandi" : ""}
                            onClick={() => {
                              if (anket.tamamlandiMi === true) return;
                              handleAnketBaslat(anket);
                            }}
                          >
                            {anket.tamamlandiMi === true
                              ? tx("Tamamlandı")
                              : "Ankete Başla"}
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
          </div>
        );

      case "profilAyarlari":
        return (
          <div className="personel-icerik profil-ayar-page">
            <div className="profil-ayar-header">
              <div>
                <h2>{tx("Profil Ayarlarım")}</h2>
                <p>{tx("E-posta, telefon ve profil fotoğrafı bilgilerinizi buradan güncelleyebilirsiniz.")}</p>
              </div>

              <button
                className="profil-ayar-refresh-btn"
                onClick={fetchProfilAyarBilgileri}
                disabled={profilAyarLoading}
              >
                {tx(profilAyarLoading ? "Yükleniyor..." : "Bilgileri Yenile")}
              </button>
            </div>

            {profilAyarMesaj && (
              <p className="profil-ayar-success">{profilAyarMesaj}</p>
            )}

            {profilAyarHata && (
              <p className="profil-ayar-error">{profilAyarHata}</p>
            )}

            <CareerProfilePhotoCard photo={profilePhoto} busy={profilFotoLoading} onChange={handleProfilFotoDegistir}/>

            <div
              className={`profil-ayar-card ${contactModal.open && contactModal.type === "email"
                ? "profil-ayar-card-open"
                : ""
                }`}
            >
              <div className="profil-ayar-icon">✉️</div>

              <div className="profil-ayar-info">
                <span>{tx("E-posta")}</span>
                <strong>{profilAyar.email || "E-posta bilgisi bulunamadı"}</strong>
              </div>

              <button
                type="button"
                className={`profil-ayar-change-btn ${contactModal.open && contactModal.type === "email"
                  ? "profil-ayar-close-btn"
                  : ""
                  }`}
                disabled={contactLoading}
                onClick={() => {
                  if (contactModal.open && contactModal.type === "email") {
                    closeContactModal();
                  } else {
                    openContactModal("email");
                  }
                }}
              >
                {contactModal.open && contactModal.type === "email" ? "×" : tx("Değiştir")}
              </button>

              {renderContactInlineForm("email")}
            </div>

            <div
              className={`profil-ayar-card ${contactModal.open && contactModal.type === "phone"
                ? "profil-ayar-card-open"
                : ""
                }`}
            >
              <div className="profil-ayar-icon">📱</div>

              <div className="profil-ayar-info">
                <span>{tx("Telefon")}</span>
                <strong>
                  {profilAyar.phone
                    ? profilePhone(profilAyar.phone)
                    : tx("Telefon bilgisi bulunamadı")}
                </strong>
              </div>

              <button
                type="button"
                className={`profil-ayar-change-btn ${contactModal.open && contactModal.type === "phone"
                  ? "profil-ayar-close-btn"
                  : ""
                  }`}
                disabled={contactLoading}
                onClick={() => {
                  if (contactModal.open && contactModal.type === "phone") {
                    closeContactModal();
                  } else {
                    openContactModal("phone");
                  }
                }}
              >
                {contactModal.open && contactModal.type === "phone" ? "×" : tx("Değiştir")}
              </button>

              {renderContactInlineForm("phone")}
            </div>
          </div>
        );

      case "ekipEgitimDurumu":
        return <EgitimDashboard />;

      case "magazaIlanlarim":
        return <MagazaIlanlarim />;
      case "paylasilanAdaylar":
        return <PaylasilanAdaylar />;
      case "mail":
        return <CareerMailbox />;

      default:
        return <div className="personel-icerik">{tx("İçerik seçilmedi.")}</div>;
    }
  };

  return (
    <div className="personel-container">
      <div
        className={`personel-sidebar ${sidebarCollapsed ? "collapsed" : ""} ${sidebarPinned ? "pinned" : ""
          }`}
        onMouseEnter={() => {
          if (!sidebarPinned) {
            setSidebarCollapsed(false);
          }
        }}
        onMouseLeave={() => {
          if (!sidebarPinned) {
            setSidebarCollapsed(true);
          }
        }}
      >

        <button
          type="button"
          className="personel-sidebar-toggle"
          onClick={(e) => {
            e.stopPropagation();

            if (sidebarPinned) {
              setSidebarPinned(false);
              setSidebarCollapsed(false);
            } else {
              setSidebarPinned(true);
              setSidebarCollapsed(false);
            }
          }}
          title={sidebarPinned ? "Otomatik moda al" : "Menüyü sabitle"}
        >
          {sidebarCollapsed ? (
            <PanelLeftOpen size={18} strokeWidth={2.4} />
          ) : (
            <PanelLeftClose size={18} strokeWidth={2.4} />
          )}
        </button>

        <div className="personel-user-info">
          <div className="personel-avatar">
            {profilePhoto ? (
              <img src={profilePhoto} alt={tx("Profil")} />
            ) : (
              <div className="navbar-user-photo-placeholder">👤</div>
            )}
          </div>
          <h3>{kullaniciAdi}</h3>
          <p>{kullaniciMail}</p>
        </div>

        <ul className="personel-menu">
          {magazaMuduruMu && (
            <li
              className={aktifMenu === "ekipEgitimDurumu" ? "aktif" : ""}
              onClick={() => setAktifMenu("ekipEgitimDurumu")}
            >
              <span className="personel-menu-icon">
                <LayoutDashboard size={22} strokeWidth={2.3} />
              </span>
              <span className="personel-menu-text">Dashboard</span>
            </li>
          )}

          {ilanPaylasimErisimiVar && (
            <li
              className={aktifMenu === "magazaIlanlarim" ? "aktif" : ""}
              onClick={() => setAktifMenu("magazaIlanlarim")}
            >
              <span className="personel-menu-icon">
                <BriefcaseBusiness size={22} strokeWidth={2.3} />
              </span>
              <span className="personel-menu-text">{tx("İlanlarım")}</span>
            </li>
          )}

          {adayPaylasimErisimiVar&&<li role="button" tabIndex={0} aria-label="Paylaşılan Adaylar"
            className={aktifMenu==='paylasilanAdaylar'?'aktif':''}
            onClick={()=>setAktifMenu('paylasilanAdaylar')}
            onKeyDown={e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();setAktifMenu('paylasilanAdaylar');}}}>
            <span className="personel-menu-icon"><FileText size={22} strokeWidth={2.3}/></span><span className="personel-menu-text">Paylaşılan Adaylar</span>
          </li>}
          <li
            className={aktifMenu === "profilAyarlari" ? "aktif" : ""}
            onClick={() => setAktifMenu("profilAyarlari")}
          >
            <span className="personel-menu-icon">
              <Settings size={22} strokeWidth={2.3} />
            </span>
            <span className="personel-menu-text">{tx("Profil Ayarlarım")}</span>
          </li>

          <li
            className={location.pathname === "/ozgecmisim" ? "aktif" : ""}
            onClick={() => navigate("/ozgecmisim")}
          >
            <span className="personel-menu-icon">
              <UserRound size={22} strokeWidth={2.3} />
            </span>
            <span className="personel-menu-text">{tx("Özgeçmişim")}</span>
          </li>

          <li
            className={aktifMenu === "egitimler" ? "aktif" : ""}
            onClick={() => setAktifMenu("egitimler")}
          >
            <span className="personel-menu-icon">
              <BookOpen size={22} strokeWidth={2.3} />
            </span>
            <span className="personel-menu-text">{tx("Eğitimlerim")}</span>
          </li>

          <li
            className={aktifMenu === "sertifikalar" ? "aktif" : ""}
            onClick={() => setAktifMenu("sertifikalar")}
          >
            <span className="personel-menu-icon">
              <BadgeCheck size={22} strokeWidth={2.3} />
            </span>
            <span className="personel-menu-text">{tx("Sertifikalarım")}</span>
          </li>

          <li
            className={aktifMenu === "evraklar" ? "aktif" : ""}
            aria-label={tx("Evraklarım")}
            role="button" tabIndex={0} aria-current={aktifMenu==='evraklar'?'page':undefined}
            onClick={() => setAktifMenu("evraklar")}
            onKeyDown={e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();setAktifMenu('evraklar');}}}
          >
            <span className="personel-menu-icon">
              <FileText size={22} strokeWidth={2.3} />
            </span>
            <span className="personel-menu-text">{tx("Evraklarım")}</span>
          </li>

          <li
            className={aktifMenu === "sinavlar" ? "aktif" : ""}
            onClick={() => setAktifMenu("sinavlar")}
          >
            <span className="personel-menu-icon">
              <FileQuestion size={22} strokeWidth={2.3} />
            </span>
            <span className="personel-menu-text">{tx("Sınavlarım")}</span>
          </li>

          <li
            className={aktifMenu === "anketlerim" ? "aktif" : ""}
            onClick={() => setAktifMenu("anketlerim")}
          >
            <span className="personel-menu-icon">
              <ClipboardList size={22} strokeWidth={2.3} />
            </span>
            <span className="personel-menu-text">{tx("Anketlerim")}</span>
          </li>

          <li className={aktifMenu === "mail" ? "aktif" : ""} onClick={() => setAktifMenu("mail")}>
            <span className="personel-menu-icon"><Mail size={22} strokeWidth={2.3}/></span>
            <span className="personel-menu-text">Mail</span>
          </li>

          {shiftYetkisiVar && (
            <li
              className={location.pathname === "/personel/shift-yonetimi" ? "aktif" : ""}
              onClick={() => navigate("/personel/shift-yonetimi")}
            >
              <span className="personel-menu-icon">
                <CalendarClock size={22} strokeWidth={2.3} />
              </span>
              <span className="personel-menu-text">{tx("Shift Yönetimi")}</span>
            </li>
          )}

        </ul>
      </div>

      <div className={'personel-content'+(aktifMenu==='mail'?' personel-content-mail':'')}>{renderIcerik()}</div>


      {seciliEgitim && (
        <div className="egitim-modal-overlay1">
          <div className="egitim-modal">
            <button
              className="modal-close"
              onClick={() => setSeciliEgitim(null)}
            >
              ✖
            </button>

            <LegacyEgitimStep
              egitim={seciliEgitim}
              onClose={() => setSeciliEgitim(null)}
            />
          </div>
        </div>
      )}

      {buyukSertifika && (
        <div
          className="sertifika-popup-overlay"
          onClick={() => setBuyukSertifika(null)}
        >
          <div className="sertifika-popup">
            <img src={buyukSertifika} alt={tx("Sertifika Büyük")} />
          </div>
        </div>
      )}

      {showModul4Warning && (
        <div className="modul-uyari-overlay">
          <div className="modul-uyari-popup">
            <p>{modul4WarningMessage}</p>
            <button onClick={() => setShowModul4Warning(false)}>{tx("Tamam")}</button>
          </div>
        </div>
      )}

      {showEksikBilgiPopup && (
        <div className="eksik-bilgi-popup-overlay">
          <div className="eksik-bilgi-popup">
            <h2>{tx("Eksik Bilgi Bulunmaktadır")}</h2>

            <p>{tx("Özgeçmişinizde eksik bilgiler bulunmaktadır, lütfen tamamlayınız.")}</p>

            <button type="button" onClick={handleEksikBilgiTamam}>{tx("Tamam")}</button>
          </div>
        </div>
      )}

      {showCropper && (
        <CropperPopup
          image={cropImageUrl}
          onCancel={() => setShowCropper(false)}
          onCropComplete={async (croppedBlob) => {
            if (profilFotoLoading) return;

            setProfilFotoLoading(true);
            setProfilAyarHata("");
            setProfilAyarMesaj("Profil fotoğrafı kaydediliyor, lütfen bekleyin...");

            const formData = new FormData();
            formData.append("Foto", croppedBlob, "pp.jpg");

            try {
              await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppyukle`,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                  },
                }
              );

              const res = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppbak`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                  responseType: "blob",
                }
              );

              const imgUrl = URL.createObjectURL(res.data);
              setProfilePhoto(imgUrl);

              window.dispatchEvent(new Event("profilePhotoUpdated"));

              setShowCropper(false);
              setProfilAyarMesaj("Profil fotoğrafı başarıyla kaydedildi.");

            } catch (err) {
              console.error("Fotoğraf yüklenemedi:", err);
              setProfilAyarHata("Fotoğraf kaydedilirken hata oluştu.");
              setProfilAyarMesaj("");
            } finally {
              setProfilFotoLoading(false);
            }
          }}
        />
      )}

      {showSinavBilgiPopup && seciliSinav && (
        <div className="sinav-popup-overlay">
          <div className="sinav-popup">
            <button
              className="sinav-popup-close"
              onClick={handleSinavPopupKapat}
            >
              ×
            </button>

            <h2 className="sinav-popup-title">{seciliSinav.baslik}</h2>

            {seciliSinav.aciklama && (
              <p className="sinav-popup-desc">{seciliSinav.aciklama}</p>
            )}

            <div className="sinav-popup-info-grid">
              <div className="sinav-popup-info">
                <span>{tx("Süre")}</span>
                <strong>{seciliSinav.sureDakika}{tx("dk")}</strong>
              </div>

              <div className="sinav-popup-info">
                <span>{tx("Geçme Notu")}</span>
                <strong>{seciliSinav.gecmePuani}</strong>
              </div>

              <div className="sinav-popup-info">
                <span>{tx("Kalan Hak")}</span>
                <strong>{seciliSinav.kalanGirisHakki}</strong>
              </div>

              <div className="sinav-popup-info">
                <span>{tx("Son Tarih")}</span>
                <strong>{formatTarih(seciliSinav.sonTarih)}</strong>
              </div>
            </div>

            <div className="sinav-popup-rules">
              <h3>{tx("Sınav Kuralları")}</h3>

              <ul>
                <li>{tx("Sınav başladıktan sonra süre işlemeye başlar.")}</li>

                <li>{tx("Her soru için yalnızca bir cevap seçebilirsiniz.")}</li>

                <li>{tx("İşaretlediğiniz sorular sol taraftaki soru panelinde yeşil olarak gösterilecektir.")}</li>

                <li>{tx("Sorular arasında geçiş yapabilirsiniz ancak süre işlemeye devam eder.")}</li>

                <li>{tx("Tarayıcıyı kapatmanız, sayfadan çıkmanız veya geri gitmeniz durumunda sınavınız geçersiz sayılabilir.")}</li>

                <li>{tx("Süre dolduğunda sınav otomatik olarak tamamlanacaktır.")}</li>

                <li>{tx("Sınavı tamamladıktan sonra sonuç ekranınız otomatik olarak gösterilecektir.")}</li>

                <li>{tx("Geçme puanının altında sonuç almanız durumunda, kalan giriş hakkınız varsa tekrar sınava katılım sağlayabilirsiniz.")}</li>

                <li>{tx("Kalan giriş hakkınız dolduğunda sınava tekrar erişim sağlayamayabilirsiniz.")}</li>
              </ul>
            </div>
            <div className="sinav-popup-actions">
              <button
                className="sinav-popup-cancel"
                onClick={handleSinavPopupKapat}
              >{tx("Vazgeç")}</button>

              <button
                className="sinav-popup-start"
                onClick={handleSinavBaslat}
                disabled={seciliSinav?.sonGectiMi === true}
              >
                {seciliSinav?.sonGectiMi === true
                  ? "Sınav Tamamlandı"
                  : tx("Anladım")}
              </button>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonelProfil;
